export default {
    add_new_client: 'Dodaj nowego klienta',
}